import {
  MetricHeaderLeft,
  MetricHeaderMid,
  MetricHeaderRight,
  MetricHeaderWrapper,
} from "../Atom"
import { HeaderInfoNav } from "../Reusable"
import { useNavigate } from "react-router-dom"
import { ProvidersHeaderGeneralDropdownFilter } from "../../Dropdown/ProvidersHeaderDropdownFilter"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import {
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedPractices,
  setMaevaSelectedRegions,
} from "../../../redux/slices/metricSlice"

type headerProps = {
  name: string
  handleDownload?: any
  rows?: any
  setOpen?: any
  reportingTab?: any
}

const DashboardHeader = (props: headerProps) => {
  const { name } = props
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const loading = useAppSelector((state) => state.app.loading)

  const maevaGroups = useSelector((state: any) => {
    return state.metric.maevaGroups
  })

  const maevaRegions = useSelector((state: any) => {
    return state.metric.maevaRegions
  })

  const maevaPractices = useSelector((state: any) => {
    return state.metric.maevaPractices
  })

  const maevaSelectedGroup = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll?.[0]
  })

  const maevaSelectedRegion = useSelector((state: any) => {
    return state.metric.maevaSelectedRegions?.[0]
  })

  const maevaSelectedPractice = useSelector((state: any) => {
    return state.metric.maevaSelectedPractices?.[0]
  })

  const handleGroupFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedGroupsNoAll([value]))
    dispatch(setMaevaSelectedRegions([{ label: "All", name: "all" }]))
    dispatch(
      setMaevaSelectedPractices([
        { label: "All", name: "all", practice_sk: "all" },
      ]),
    )
  }

  const handleRegionFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedRegions([value]))
    dispatch(
      setMaevaSelectedPractices([
        { label: "All", name: "all", practice_sk: "all" },
      ]),
    )
  }

  const handleOfficeFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedPractices([value]))
  }

  const handleClickBack = () => {
    navigate(-1)
  }

  return (
    <MetricHeaderWrapper sx={{ justifyContent: "flex-start" }}>
      <MetricHeaderLeft>
        <HeaderInfoNav
          name={name}
          handleClickBack={handleClickBack}
          isBack={false}
        />
      </MetricHeaderLeft>

      <MetricHeaderMid>
        <Box sx={{ display: "flex" }}>
          <ProvidersHeaderGeneralDropdownFilter
            id={1}
            key={"huddle-filter-1"}
            disabled={loading}
            handleFilter={handleGroupFilter}
            filterData={maevaGroups}
            headerLabel="Group Name"
            value={maevaSelectedGroup}
            placeholder="Select a Group"
          />
          <ProvidersHeaderGeneralDropdownFilter
            id={2}
            key={"huddle-filter-2"}
            disabled={!maevaSelectedGroup || loading}
            handleFilter={handleRegionFilter}
            filterData={maevaRegions}
            headerLabel="Regions"
            value={maevaSelectedRegion}
            placeholder="Select a Region"
          />
          <ProvidersHeaderGeneralDropdownFilter
            id={3}
            key={"huddle-filter-3"}
            disabled={!maevaSelectedRegion || loading}
            handleFilter={handleOfficeFilter}
            filterData={maevaPractices}
            headerLabel="Offices"
            value={maevaSelectedPractice}
            placeholder="Select an Office"
          />
        </Box>
      </MetricHeaderMid>
      <MetricHeaderRight></MetricHeaderRight>
    </MetricHeaderWrapper>
  )
}

export default DashboardHeader
